//imports
import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  TextField,
  FormControl, Button,
  Stack,
  Breadcrumbs,
  Link,
  AppBar, InputAdornment,
  Autocomplete,
  Snackbar,
  Alert,
  useMediaQuery,Typography,Paper
 
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddToolbar from "../../components/common/AddToolbar";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import {
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import {
  images_01,
  Unit_01,
  SETTINGS_API_16, CHAINCODE, SETTINGS_API_17,
  SETTINGS_API_26
} from "../../api/ApiModel";
import {
  CON_STATUS_ACTIVE,  CON_MAX_FILESIZE_ITEMIMG,
    CON_MENUICON_WIDTH,
    CON_MENUICON_HEIGHT,
} from "../../utils/sys/Constants";
import { Tabs, Tab } from "@mui/material";
import { IMAGEBASEURL } from "../../config/Config";
import { useSelector } from "react-redux";
import ImageCropper from "../../components/common/ImageCropper";
const SetupMenumeal = () => {
  //hooks
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);

  const gotToView = () => {
    navigate("/vsetupMenumeal");
  };

  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME, BUSINESSTYPECODE } =
    SYS_USER.USER_PARAM || {};
  const [isLoading, setIsLoading] = useState(true);
  const [data2, setData2] = useState([]);
  const [error1, setError1] = useState({});
  const [error2, setError2] = useState({});
  const [error, setError] = useState({});
  const [errors, setErrors] = useState({});
  const location = useLocation();
  const { selectedItem } = location.state || {};
  const [data1, setData1] = useState([]);
  const [images, setImages] = useState([]);
  const [selectedImageUrl, setSelectedImageUrl] = useState("");
  const isSmallScreen = useMediaQuery("(max-width:600px)"); // Adjust breakpoint as needed
  const marginLeftImage = isSmallScreen
    ? selectedImageUrl
      ? 60
      : 60
    : selectedImageUrl
    ? 115
    : 95;

  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
 const [tabIndex, setTabIndex] = useState(0);
  const [croppedImg, setCroppedImg] = useState("");
  const options = [
    { label: "Yes", value: "Y" },
    { label: "No", value: "N" },
  ];

  const isEdit = location.state?.actionText === "Edit";

  const [selectedItemDetails, setSelectedItemDetails] = useState({
    MENUCATCODE: "",
    MENUCATNAME: "",

    MENUNAME: "",
    ITEMRATE: "",
    ISTAXAPPLY: "",
    KITCHENITEM: "",
    MEASURINGUNIT: "",
    MINORDERLEVEL: "0",
    BARCODE: "",
    REMARK: "",
    MENUCODE: "",
    IMAGEPATH: "",
    BYTEARRAY: "",
  });

  // Initialize selectedItemDetails and selectedImageUrl when editing
  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        MENUCATCODE: String(selectedItem.MENUCATCODE),

        MENUNAME: selectedItem.MENUNAME || "",
        ITEMRATE: String(selectedItem.ITEMRATE || ""),
        ISTAXAPPLY: selectedItem.ISTAXAPPLY || "",
        KITCHENITEM: selectedItem.KITCHENITEM || "",
        MEASURINGUNIT: selectedItem.MEASURINGUNIT || "",
        MINORDERLEVEL: String(selectedItem.MINORDERLEVEL || ""),
        BARCODE: selectedItem.BARCODE || "",
        REMARK: selectedItem.REMARK || "",
        MENUCODE: selectedItem.MENUCODE || "",
        IMAGEPATH: String(selectedItem.IMAGEPATH),
        BYTEARRAY: selectedItem.BYTEARRAY || "",
      });
    }
  }, [selectedItem]);
  // handlers
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedItemDetails({
      ...selectedItemDetails,
      [name]: value,
    });

    setError((prevError) => ({
      ...prevError,
      [name]: "",
    }));
  };

  // Fetch images
  useEffect(() => {
    fetchData();
    fetchDataimg();
    fetchDataunits();
  }, []);

  const fetchDataimg = async () => {
    try {
      const result = await externalgetApi(images_01, "get", {
        BUSINESSTYPECODE,
      });
      if (Array.isArray(result)) {
        setImages(result);
      } else {
        console.error("Expected an array, got:", result);
        setImages([]); // Set an empty array to avoid errors
      }
    } catch (err) {
      console.error("Error fetching image options:", err);
      setError(true);
    }
  };

  const handleImageClick = async (image) => {
    const imageUrl = `${IMAGEBASEURL}${image.IMAGEPATH.replace("~", "")}`;
    setSelectedImageUrl(imageUrl);
    console.log("Selected Image URL:", `${imageUrl}`);
  };

  const handleCroppedImage = (img) => {
    setCroppedImg(img);

    console.log("Received cropped image from child:", img);
  
  };


  const fetchData = async () => {
    try {
      const result = await externalgetApi(SETTINGS_API_17, "get", {
        COMPCODE,
        LOCCODE,

        RESTCODE,
      });
      setData1(result);
      setIsLoading(false);
    } catch (err) {
      setError(err);
      setIsLoading(false);
    }
  };
  //post api
  const handleConfirmClick = async () => {
    const {
      MENUNAME,
      ITEMRATE,
      ISTAXAPPLY,
      KITCHENITEM,
      MEASURINGUNIT,
      MINORDERLEVEL,
      BARCODE,
      MENUCATCODE,
      REMARK,
    } = selectedItemDetails;
    const requiredFields = [
      { name: "MENUNAME", value: MENUNAME, label: "Menu Name" },
      { name: "ITEMRATE", value: ITEMRATE, label: "Item Rate" },
      { name: "MENUCATCODE", value: MENUCATCODE, label: "Catergory name" },
      { name: "ISTAXAPPLY", value: ISTAXAPPLY, label: "Tax Apply" },
      // { name: "KITCHENITEM", value: KITCHENITEM, label: "Kitchen Item" },
      { name: "MEASURINGUNIT", value: MEASURINGUNIT, label: "Measuring Unit" },
      {
        name: "MINORDERLEVEL",
        value: MINORDERLEVEL,
        label: "Minimum Order Level",
      },

      // {
      //   name: "IMAGEPATH",
      //   value: selectedImageUrl || selectedItemDetails.IMAGEPATH,
      //   label: "Image Path",
      // },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });
      setError(newError);

      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Required fields: ${missingFieldLabels}.`;
      setSnackbarMessage(errorMessage);
      setOpenErrorSnackbar(true);
      return;
    }

    const optionalFields = {
      REMARK,
      IMAGEPATH: selectedImageUrl || selectedItemDetails.IMAGEPATH,
    };

    const menuCode = selectedItem ? String(selectedItem.MENUCODE || "") : "";

    const staticValues = {
      COMPCODE,
      LOCCODE,
      RESTCODE,
      BUSINESSTYPECODE,
      STS: CON_STATUS_ACTIVE,
      CHAINCODE,
      RATE: "",
      DISCOUNTRATE: "0.00",
      MENUREFCODE: "",

      Enuser: USERNAME,
      BRANDNAME: "N/A",
      TAXCODE: "N",
      COMMONNAME: "N/A",
      LOCDATE: new Date(),
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
      MENUCODE: menuCode,
      ...optionalFields,
      BYTEARRAY: croppedImg.length > 0 ? String(croppedImg.split(",")[1]) : "",
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SETTINGS_API_16, payload);
      console.log("Success:", responseData);
      setOpenSnackbar(true);
      handleClearClick(); // Clear form fields after success
    } catch (error) {
      console.error("Error:", error);
    }
    setTimeout(() => {
      navigate("/vsetupMenumeal");
    }, 2000);
  };

  const handleClearClick = () => {
    setSelectedItemDetails({
      MENUCATCODE: "",
      MENUNAME: "",
      ITEMRATE: "",
      ISTAXAPPLY: "",
      KITCHENITEM: "",
      MEASURINGUNIT: "",
      MINORDERLEVEL: "",
      BARCODE: "",
      REMARK: "",
      MENUCODE: "",
      IMAGEPATH: "",
    });
    setSelectedImageUrl(""); // Clear the selected image URL as well
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleErrorSnackbarClose = () => {
    setOpenErrorSnackbar(false);
  };

  const fetchDataunits = async () => {
    try {
      const result = await externalgetApi(SETTINGS_API_26, "get", {
        COMPCODE,
        LOCCODE,
        RESTCODE,

        STS: CON_STATUS_ACTIVE,
      });
      console.log("API response:", result); // Log API response

      setData2(result);
    } catch (err) {
      console.error("Error fetching data:", err);
      setError(err);
    }
  };

  const handlenumInputValidation1 = (event) => {
    const { name, value } = event.target;

    // Regular expression to allow only numbers and floats
    const regex = /^[0-9]*\.?[0-9]*$/;

    if (regex.test(value)) {
      setError1(""); // Clear any existing error message
      handleInputChange(event); // Update state with the valid input
    } else {
      setError1("Only numbers and floats are allowed."); // Set error message
    }
  };
  const handlenumInputValidation2 = (event) => {
    const { name, value } = event.target;

    // Regular expression to allow only numbers and floats
    const regex = /^[0-9]*\.?[0-9]*$/;

    if (regex.test(value)) {
      setError2(""); // Clear any existing error message
      handleInputChange(event); // Update state with the valid input
    } else {
      setError2("Only numbers and floats are allowed."); // Set error message
    }
  };

  return (
    <div>
      <Navbar />

      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Promotions</Link>
                <Link underline="none">Add Promotional Items</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{
            name: isEdit
              ? "Edit Setup Promotional Items"
              : "Setup Promotional Items",
          }}
        />
        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid item spacing={2} xs={12} sm={12} md={6} lg={6}>
            <Grid item xs={12} sm={12}>
              <FormControl size="small" fullWidth>
                <Autocomplete
                  options={data1}
                  required
                  getOptionLabel={(option) => option.MENUCATNAME || ""} // Display MENUCATNAME in dropdown
                  value={
                    data1.find(
                      (item) =>
                        String(item.MENUCATCODE) ===
                        String(selectedItemDetails.MENUCATCODE)
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    // Update both MENUCATCODE and MENUCATNAME in state
                    handleInputChange({
                      target: {
                        name: "MENUCATNAME",
                        value: newValue ? newValue.MENUCATNAME : "",
                      },
                    });
                    handleInputChange({
                      target: {
                        name: "MENUCATCODE",
                        value: newValue ? String(newValue.MENUCATCODE) : "",
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Item Category"
                      variant="outlined"
                      required
                      error={!!error.MENUCATCODE}
                      helperText={error.MENUCATCODE}
                      size="small"
                    />
                  )}
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} mt={2}>
              <TextField
                label="Promotional Items"
                required
                size="small"
                fullWidth
                variant="outlined"
                name="MENUNAME"
                value={selectedItemDetails.MENUNAME}
                onChange={handleInputChange}
                autoComplete="off"
                error={!!error.MENUNAME}
                helperText={error.MENUNAME}
              />
            </Grid>
            <Grid item xs={12} sm={12} mt={2}>
              <TextField
                label="Rate"
                required
                fullWidth
                size="small"
                variant="outlined"
                name="ITEMRATE"
                value={selectedItemDetails.ITEMRATE}
                onChange={handlenumInputValidation1}
                autoComplete="off"
                error={!!error.ITEMRATE}
                helperText={error.ITEMRATE}
              />
            </Grid>
            <Grid item xs={12} sm={12} mt={2}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={options}
               
                  getOptionLabel={(option) => option.label}
                  value={
                    options.find(
                      (option) =>
                        option.value === selectedItemDetails.ISTAXAPPLY
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleInputChange({
                      target: {
                        name: "ISTAXAPPLY",
                        value: newValue ? newValue.value : "",
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Special Tax Applied (Reporting purpose)"
                      variant="outlined"
                      error={!!error.ISTAXAPPLY}
                      helperText={error.ISTAXAPPLY}
                   
                      size="small"
                    />
                  )}
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                />
              </FormControl>
            </Grid>
            {/* <Grid item xs={12} sm={12} mt={2}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={options}
                  getOptionLabel={(option) => option.label}
                  value={
                    options.find(
                      (option) =>
                        option.value === selectedItemDetails.KITCHENITEM
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleInputChange({
                      target: {
                        name: "KITCHENITEM",
                        value: newValue ? newValue.value : "",
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Kitchen Item"
                      variant="outlined"
                      error={!!error.KITCHENITEM}
                      helperText={error.KITCHENITEM}
                      size="small"
                    />
                  )}
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                />
              </FormControl>
            </Grid> */}
           <Grid item xs={12} sm={12} mt={2}>
                      <FormControl fullWidth size="small">
                        <Autocomplete
                          options={data2}
                       
                          getOptionLabel={(option) => option.MEASURINGUNIT || ""} // Ensure a fallback for undefined values
                          value={
                            data2.find(
                              (item) => item.MEASURINGUNIT == selectedItemDetails.MEASURINGUNIT
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            handleInputChange({
                              target: {
                                name: "MEASURINGUNIT",
                                value: newValue ? newValue.MEASURINGUNIT : "", // Set MEASURINGUNIT or empty string
                              },
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Measuring Unit"
                              size="small"
                              name="MEASURINGUNIT"
                              error={Boolean(errors.MEASURINGUNIT)}
                              helperText={errors.MEASURINGUNIT}
                            />
                          )}
                          ListboxProps={{
                            style: {
                              maxHeight: 150,
                              backgroundColor: theme.palette.background.paper,
                            },
                          }}
                        />
                      </FormControl>
                    </Grid>
          </Grid>
          <Grid item spacing={2} xs={12} sm={12} md={6} lg={6}>
            <Grid item xs={12} sm={12}>
            <TextField
  label="Minimum Order Level"
  name="MINORDERLEVEL"
  size="small"
  fullWidth
  variant="outlined"
  autoComplete="off"
  value={selectedItemDetails.MINORDERLEVEL}
  error={!!error.MINORDERLEVEL}
  helperText={error.MINORDERLEVEL}
  onFocus={(e) => {
    if (selectedItemDetails.MINORDERLEVEL === "0") {
      handleInputChange({ target: { name: "MINORDERLEVEL", value: "" } });
    }
  }}
  onChange={handlenumInputValidation2}
/>
            </Grid>
            <Grid item xs={12} sm={12} mt={2}>
              <TextField
                label="Barcode"
                size="small"
                name="BARCODE"
                fullWidth
                variant="outlined"
                autoComplete="off"
                value={selectedItemDetails.BARCODE}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={12} mt={2}>
              <TextField
                label="Remark"
                size="small"
                fullWidth
                variant="outlined"
                name="REMARK"
                value={selectedItemDetails.REMARK}
                onChange={handleInputChange}
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={12} sm={12} mt={2}>
              <Tabs
                value={tabIndex}
                onChange={(e, newIndex) => setTabIndex(newIndex)}
              >
                <Tab label="Select Icon" />
                <Tab label="Upload Image" />
              </Tabs>
            </Grid>
            {tabIndex === 0 && (
              <Grid container spacing={3}>
                {/* <Addradio value={matchingItem.IMAGEPATH} /> */}
                <Grid item xs={8} sm={8} md={8} lg={8} xl={8} mt={2}>
                  <TextField
                    name="IMAGEPATH"
                    value={selectedImageUrl} // Display the selected image URL
                    label="Icon"
                    fullWidth
                    sx={{
                      height: 180,
                      "& .MuiInputBase-root": {
                        height: "100%",
                        width: "min-content",
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              mt: 1,
                              maxWidth: {
                                xs: "400px",
                                sm: "600px",
                                md: "900px",
                                lg: "1200px",
                                xl: "1536px",
                              },
                              // width: "100%",
                              height: 150,
                              overflowY: "auto",
                              border: "1px solid #ddd",
                            }}
                          >
                            <Box
                              sx={{
                                display: "grid",
                                gridTemplateColumns: {
                                  xs: "repeat(4, 1fr)", // On extra-small screens, 3 columns
                                  sm: "repeat(8, 1fr)", // On small screens, 4 columns
                                  md: "repeat(8, 1fr)", // On medium and larger, 5 columns
                                  lg: "repeat(12, 1fr)",
                                  xl: "repeat(12, 1fr)",
                                },
                                gap: "8px",
                                width: "100%",
                              }}
                            >
                              {images.map((image) => (
                                <img
                                  key={image.IMAGEPATH}
                                  src={`${IMAGEBASEURL}${image.IMAGEPATH.replace(
                                    "~",
                                    ""
                                  )}`}
                                  alt="icon"
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    cursor: "pointer",
                                    verticalAlign: "middle",
                                  }}
                                  onClick={() => handleImageClick(image)}
                                />
                              ))}
                            </Box>
                          </Box>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    height={"100%"}
                  >
                    {(selectedImageUrl || selectedItemDetails?.IMAGEPATH) && (
                      <img
                        src={
                          selectedImageUrl
                            ? `${selectedImageUrl}` // Use selectedImageUrl if available
                            : `${selectedItemDetails?.IMAGEPATH}` // Use matchingItem?.IMAGEPATH as fallback
                        }
                        alt="Selected or Matching Item"
                        style={{
                          // width: "100px",
                          height: "auto",
                          maxHeight: "100px",
                          // marginTop: "20%",
                          // marginLeft: marginLeftImage,

                          cursor: "pointer",
                        }}
                      />
                    )}
                  </Box>
                </Grid>
              </Grid>
            )}
            {tabIndex === 1 && (
              <Grid container spacing={1} mt={0}>
                <Grid item xs={6} sm={6} md={6} lg={6} xl={6} pt={0}>
                  <Box>
                    <ImageCropper
                      onCropComplete={handleCroppedImage}
                      FIXED_WIDTH={CON_MENUICON_WIDTH}
                      FIXED_HEIGHT={CON_MENUICON_HEIGHT}
                      MAX_FILESIZE={CON_MAX_FILESIZE_ITEMIMG}
                      setSnackbarMessage={setSnackbarMessage}
                      setOpenErrorSnackbar={setOpenErrorSnackbar}
                      setMatchingItem={setSelectedItemDetails}
                    />
                  </Box>
                </Grid>

                <Grid item xs={6} sm={6} md={6} lg={6} xl={6} pt={0}>
                  {croppedImg && (
                    <Box sx={{ flexDirection: "column", alignItems: "end" }}>
                      <Typography variant="subtitle1">Preview:</Typography>
                      <Paper
                        elevation={3}
                        sx={{ width: "fit-content", padding: 2 }}
                      >
                        <img
                          src={croppedImg}
                          alt="Cropped Result"
                          style={{ width: 150, height: 150 }}
                        />
                      </Paper>
                    </Box>
                  )}
                </Grid>
              </Grid>
            )}
            <Grid item xs={12} sm={12}></Grid>
            <Grid item xs={12} sm={12}></Grid>
            <Grid item xs={12} sm={12}></Grid>
          </Grid>
        </Grid>

        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
          >
            {" "}
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Stack>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {isEdit ? "Updated Successfully!" : " Created Successfully!"}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          message={snackbarMessage}
          autoHideDuration={6000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage || "Please fill out all fields before submitting."}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default SetupMenumeal;
